<template>
  <fragment>
    <t-router-link v-if="product.category" :to="{ name: 'shop.product', params: { productSlug: $options.filters.st(product.slug), categorySlug: $options.filters.st(product.category.slug) } }">
      <slot>{{ product.name|st }}</slot>
    </t-router-link>
    <template v-else>
      <slot>{{ product.name|st }}</slot>
    </template>
  </fragment>
</template>

<script>
export default {
  name: 'ProductLink',
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
